import React from "react";
import { Footer, FooterRight } from "../../packages/excalidraw/index";
import { EncryptedIcon } from "./EncryptedIcon";
import { ExcalidrawPlusAppLink } from "./ExcalidrawPlusAppLink";
import { isExcalidrawPlusSignedUser } from "../app_constants";
import FeedbackButton from "./canvas/feedback/FeedbackButton";

export const AppFooter = React.memo(() => {
  return (
    <>
      <Footer>
        <div
          style={{
            display: "flex",
            gap: ".5rem",
            alignItems: "center",
          }}
        >
          {isExcalidrawPlusSignedUser ? (
            <ExcalidrawPlusAppLink />
          ) : (
            <EncryptedIcon />
          )}
        </div>
      </Footer>

      {/* Bottom-right, immediately left of the help button. */}
      <FooterRight>
        <FeedbackButton />
      </FooterRight>
    </>
  );
});
